import React from 'react';
import PropTypes from 'prop-types';

const CreditorsResultRow = ({ row }) => (
  <table className="ir-search-table-results sticky-enabled">
    <tbody>
      <tr>
        <td>
          <span className="address-name" dangerouslySetInnerHTML={{ __html: row.name }} />
          <br />
          <span style={{ whiteSpace: 'pre-wrap' }}>{row.address}</span>
        </td>
        <td>
          {row.creditor_code}
        </td>
        <td>
          {row.creditor_role ? `(${row.creditor_role})`: ''}
        </td>
      </tr>
    </tbody>
  </table>
);

CreditorsResultRow.propTypes = {
  row: PropTypes.any.isRequired,
};

export default CreditorsResultRow;



// WEBPACK FOOTER //
// ./src/components/advancedSearch/results/rows/CreditorsResultRow.jsx